import { html } from "@microsoft/fast-element";
import { MultiView } from "./multi-view.js";
/**
 * Generates the template for the {@link @fabric-msft/fabric-web#MultiView} component.
 *
 * @public
 * @remarks
 * This template provides the HTML structure and bindings for the `MultiView` component.
 * It includes a slot for `multi-view` and dynamically manages the visibility and focus
 * based on the `hidden` property of the `MultiView`.
 *
 * @returns {ElementViewTemplate<MultiView>} The template for the `MultiView` component.
 *
 * @csspart multi-view - The main container for the view content.
 */
function multiViewTemplate() {
    return html `
    <template
      slot="multi-view"
      role="tabpanel"
      ?hidden="${(x) => x.hidden}"
      aria-hidden="${(x) => x.hidden}"
      tabindex="${(x) => (!x.hidden ? "0" : "-1")}"
    >
      <div class="multi-view" part="multi-view">
        <slot></slot>
      </div>
    </template>
  `;
}
/**
 * The template for the {@link @fabric-msft/fabric-web#MultiView} component.
 * @public
 */
export const template = multiViewTemplate();
//# sourceMappingURL=multi-view.template.js.map